import styled from 'styled-components';
import { Icon } from '../../stories/atoms';

export const StyledProfileImage = styled.img<{ isMobile?: boolean }>`
  height: ${({ theme, isMobile }) => (isMobile ? theme.spacing(11) : theme.spacing(20))};
  cursor: pointer;
`;

export const StyledPlusIcon = styled(Icon)`
  width: ${({ theme }) => theme.spacing(8)};
  height: ${({ theme }) => theme.spacing(8)};
  background-color: ${({ theme }) => (theme.palette.mode === 'dark' ? theme.color.white : theme.color.primary)};
  color: ${({ theme }) => (theme.palette.mode === 'dark' ? theme.color.primary : theme.color.white)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
